export default __webpack_public_path__ + "static/media/account-ico-pass.dbf97291.svg";